<template>
  <div class="container-fluid mt--5 tbl-flt-sch">
    <div class="abs-btn-grp">
      <!-- Table Search -->
      <form  @submit.prevent="" class="d-inline-flex mt-0">
        <i @click="searchHolding()" data-v-d13f7de6="" aria-hidden="true" class="fas fa-search active cursor-pointer"></i>
        <input v-on:keyup.enter="searchHolding" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)"  data-v-d13f7de6="" type="text" placeholder="Search Here" aria-label="Search" class="form-control form-control-sm ml-3 mr-3">
        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
      
      </form>

      <!-- <Button type="button" class="btn btn-success"><i class="fas fa-dollar-sign"></i> Sell All</Button>
      <Button type="button" class="btn btn-dark" ><i class="fas fa-check-double"></i> Authorize All</Button> -->
    </div>
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
                      <thead class="thead-light psticky">
                      <tr >
                        <th 
                        scope="col" 
                        class="sort text-left"
                        >CUSTOMER | ACCOUNT</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >CUSIP/DESC</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >COUPON</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >MATURITY DATE/<br>CALL DATE</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >MOODY'S/ <br>S&P RATING</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >INSURER</th>
                        <!-- <th 
                        scope="col" 
                        class="sort text-center"
                        >BOUGHT</th> -->
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >COST</th>
                        <!-- <th 
                        scope="col" 
                        class="sort text-center"
                        >CLOSING PX</th> -->
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >TRADER/ADMIN</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >OPERATOR</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >SELL QTY</th>
                        <!-- <th 
                        scope="col" 
                        class="sort text-center"
                        >SPREAD</th>   -->
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >HOLDINGS</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="holding in holdingsList" :key="holding.id"  >
                        <td class="text-left">
                          <div v-for="customer in holding.bidWantedInventoryListDtoAccount"  :key="customer.id">
                            <span class="text-primary">{{customer.customerFirstName ? customer.customerFirstName[0] : ""}} {{customer.customerLastName}}</span>
                            | <span class="text-success">{{customer.accountVal}}</span> 
                          </div>
                        </td>
                        <td class="text-center">
                            <span class="cusips">{{holding.cusipVal}}</span><br>
                            <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                        </td>
                        <td class="text-center"><span>{{holding.coupon |  percent(3) }}</span></td>
                        <td class="text-center">
                          <span class="maturity">{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                        {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                        </td>
                        <td class="text-center"><span class="text-primary">{{holding.ratingMoody ? holding.ratingMoody : "N/A"}}</span>
                            <span class="insurer text-success">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                        </td>
                        <td class="text-center"><span class="insurer">{{holding.bondInsurer ? holding.bondInsurer : "N/A"}}</span></td>
                        <!-- <td class="text-center">
                            <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                        </td> -->
                        <td class="text-center">
                            <span class="text-success">{{holding.cost | currency}}</span><br>
                        </td>
                        <!-- <td class="text-center">
                            <span class="text-danger">{{holding.closingPx}}</span><br>
                        </td> -->
                        <td class="text-center">
                            <span>{{holding.traderFirstName}} {{holding.traderLastName}}</span><br>
                        </td>
                        <td class="text-center">
                            <span v-if="holding.operatorCognitoSub && holding.operatorCognitoSub != cognitoSub">{{holding.operatorFirstName}} {{holding.operatorLastName}}</span>
                            
                            <span class="text-success" v-if="holding.operatorCognitoSub === cognitoSub">Me</span>
                        </td>   
                        <td class="text-center">
                            <span>{{holding.sellQuantity}}</span>
                        </td>
                        <!-- <td class="text-center">
                            <span>{{holding.spread ? holding.spread.toFixed(3) : ""}}</span>
                        </td>  -->
                        <td class="text-center">
                          <a @click="toggleViewHoldingModalOpen(holding.bidWantedInventoryListDto)" class="btn ibtn btn-outline-primary mb-2" title="Holding"><i class="far fa-user mb-2"></i></a>
                          <button  v-if="isOperator" :disabled="holding.operatorCognitoSub" @click="assignToMe(holding)" type="button" class="btn btn-primary" >ASSIGN TO ME</button>
                          <button  v-if="isOperator" :disabled="!(holding.operatorCognitoSub === cognitoSub)" @click="toggleCreateBidWantedModalOpen(),selectedHolding = holding" type="button" class="btn btn-success" >SEND TO ECN</button>
                        </td>
                        </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getHoldingList(currentPage)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
    <CreateBidWanted  v-bind:holding="selectedHolding" v-if="createBidWantedModalOpen" @close="toggleCreateBidWantedModalOpen()" />
    <ViewHoldings  v-bind:holding="holdingsInBidWanted" v-if="viewHoldingModalOpen" @close="toggleViewHoldingModalOpen()" />
    
  </div>    
</template>
<script>
import CreateBidWanted from '../../ba-common/BaCreateBidWantedModal'
import config from "@/config";
import authService from "@/authService";
import ViewHoldings from '../../ba-common/BaViewHoldingListModal';
export default {
  name: "baAllHoldingsTrader",
  components : {
    CreateBidWanted,
    ViewHoldings
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        sortColumn: "id",
        sortOrder:"DESC",
        totalRows : 0,
        createBidWantedModalOpen : false,
        holdingsList : [],
        selectedHolding : null,
        cognitoSub: authService.getUser().cognitoSub,
        isOperator : window.location.pathname.includes('operator'),
        viewHoldingModalOpen : false,
        holdingsInBidWanted : []


    };
  },
  methods: {
    toggleViewHoldingModalOpen(holdings){
      this.holdingsInBidWanted = holdings
      this.viewHoldingModalOpen = !this.viewHoldingModalOpen;
    },
    getAutheriseList(){

    },
    searchHolding(){
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    toggleCreateBidWantedModalOpen(){
      this.createBidWantedModalOpen = !this.createBidWantedModalOpen;
      if(!this.createBidWantedModalOpen){
        this.getHoldingList();  
      }
    },
    getHoldingList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidwanted/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=NEW,ASSIGNED_TO_OPERATOR"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach((data) => {
            const key = 'customerId';
            const accountKey = 'accountMapId'
            const customers = [...new Map(data.bidWantedInventoryListDto.map(item => [item[key], item])).values()];
            const accounts = [...new Map(data.bidWantedInventoryListDto.map(item => [item[accountKey], item])).values()];
            data.bidWantedInventoryListDtoCopy = customers;
            data.bidWantedInventoryListDtoAccount = accounts;
          });
          this.holdingsList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    assignToMe(holding){
      var message = `Are you sure you want to assign this holding to you?`;
      this.$confirm(message,"","question",{confirmButtonText:"YES",cancelButtonText : "NO"}).then(() => {
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        let data = {
            "id": holding.id,
            "cognitoSub" : authService.getUser().cognitoSub
        }
        this.$http
        .put(config.baseUrlBidSide + "/bidwanted/assign-to-me",data,auth)
        .then(() => {
            this.loading = false; 
            this.getHoldingList();             
            this.$alert("Holding has been successfully assigned to you.","","success")
        })
        .catch(() => {
            this.loading = false;              
        });
    })
      }
  },
  mounted() {
    this.getHoldingList();
  }
};
</script>